import Header from "@/components/Header";
import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import QuoteSection from "@/components/QuoteSection";
import HowItWorks from "@/components/HowItWorks";
import ServiceAreas from "@/components/ServiceAreas";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import StickyMobileBar from "@/components/StickyMobileBar";

const HomePage = () => (
    <div className="min-h-screen overflow-x-clip bg-obsidian font-body text-slate-100 antialiased">
        <Header />
        <main>
            <Hero />
            <BrandMarquee />
            <QuoteSection />
            <HowItWorks />
            <ServiceAreas />
            <FAQ />
        </main>
        <Footer />
        <StickyMobileBar />
    </div>
);

export default HomePage;
